export default function AtcFlightsListBaseController(
    $scope,
    $rootScope,
    $state,
    baseEvents,
    atcFlightsFactory,
    l10nService,
    atcFlightFareService,
    atcFlightsService,
    atcFlightFiltersService,
    flightResultsSortTypes,
) {
    'ngInject';

        activate();
        initWatchers();

        function activate() {
            const labels = {
                showDetails: l10nService.localize('See flight details'),
                hideDetails: l10nService.localize('Hide flight details'),
            };

            $scope.flightFareService = atcFlightFareService;
            $scope.composeCompanyLogoUrl = atcFlightsService.getFlightSupplierLogo;

            $scope.selectedFlights = {};

            $scope.labels = labels;

            const flightsResponse = atcFlightsFactory.getFlights();

            $scope.flights = _.omit(flightsResponse, 'Recommendations');
            $scope.flights.Recommendations = flightsResponse.Recommendations;

            if (_.isEmpty($scope.flights)) {
                return $state.go('main.atc.check');
            }

            $scope.FareTypeTooltips = {
                Standard: l10nService.localize('These fares are typically the most restrictive'),
                Negotiated: l10nService.localize('A Key Travel special fare which may include flexible conditions'),
                Charity: l10nService.localize('A holdable and flexible fare with minimal airline charges for changes or cancellations'),
            };

            $scope.filterBySegmentModel = angular.copy(atcFlightsFactory.params.SegmentFilterData);
            atcFlightsFactory.resetSegmentFilterData();

            $scope.loadMore = loadMore;
            $scope.searchParameters = atcFlightsFactory.params;
        }

        function loadMore() {
            atcFlightsFactory.loadMoreFlights();
            $scope.flights = atcFlightsFactory.getFlights();
        }

        function initWatchers() {
            let isInitialized = false;
            $scope.$watchCollection('searchParameters.filterByGroup', () => {
                if (!isInitialized) {
                    isInitialized = true;
                    return;
                }
                filterBySegment();
            });
            $scope.$on(baseEvents.FLIGHT_CLEAR_FILTERS_ENDED, () => {
                $scope.searchParameters.filterByGroup = [];
                $scope.searchParameters.GroupByPrice = true;
                $scope.searchParameters.SortByType = flightResultsSortTypes.CHEAPEST.value;
            });
            $scope.$on(baseEvents.CLEAR_SEGMENTS, () => $scope.filterBySegmentModel.length = 0);
            $rootScope.$on(baseEvents.FLIGHT_FILTER_SEARCH_ENDED, function() {
                $scope.flights = atcFlightsFactory.getFlights();
            });
        }

        function filterBySegment() {
            const isSelected = $scope.searchParameters.filterByGroup
                && $scope.searchParameters.filterByGroup.length;

            atcFlightFiltersService.flightIsSelected = isSelected;
            if (isSelected) {
                const groups = [];
                $scope.flights.Recommendations.forEach((recommendation) =>
                    recommendation.FlightSegments.forEach((segment) =>
                        segment.FlightGroups.forEach((group) => groups.push(group))));
                const selectedGroups = groups
                    .filter(({FlightGroupHash}) => $scope.searchParameters.filterByGroup.includes(FlightGroupHash))
                    .map(({FlightGroupId}) => FlightGroupId);
                $scope.searchParameters.SegmentFilterData = Array.from(new Set(selectedGroups));
            } else {
                $scope.searchParameters.SegmentFilterData = [];
            }

            atcFlightsFactory.filterBySegment()
                .then(({data: {Recommendations, FilteredTotal}}) => {
                    Object.assign($scope.flights, {Recommendations, FilteredTotal});
                    $rootScope.$broadcast(baseEvents.APPLY_FILTERS);
            });
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcFlightsListBaseController.js